export default __webpack_public_path__ + "static/media/electric-oven-gray.62a4eb6a.svg";